import React, { Component } from 'react';
import classes from './NeverAskAgainPopup.scss';
import MfaModal from '../Modal/MfaModal';
import { getLocalizedStrings } from  '../mfaPageLocalizedStrings';
import LoadIndicator from '../../../../Common/CommonComponents/LoadingIndicator/loadingIndicator';
class NeverAskAgainPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader:false
    };
    this.strings = getLocalizedStrings('NeverAskAgain');
  }

  handleNeverAsk = (profile) => {
    this.setState({showLoader: true});
    let customerEmail = app.appService.getLocalStorage('mfaInfo') ? JSON.parse(app.appService.getLocalStorage('mfaInfo')).emailId : '';
    const reqObj = {
      email: customerEmail,
      eixSCEMFAStatus: 'NeverAsk'
    };

    app.appService.setSessionstorage('profile', true);
    profile && app.appService.customPostLoginNavigation(app.appUtil.getAppRoutes().BILLING.SETTINGS_PROFILE);
    if (window.location.pathname === '/residential/rates/rate-plan-comparison-tool' && profile === false) {
      app.appService.setLocalStorage('userpath', app.appUtil.getAppRoutes().RATEANALYZER.RATE_LOADING_RESIDENTIAL);
      app.appService.setLocalStorage('isPortalUserAuthenticated', true);
      app.appService.setSessionstorage('RateAnalyzerLoggedInStatus', true);
    }
    const { isSpocUser } = app.appService.getSessionstorage('nonMigratedData') || {};
    if (isSpocUser) {
      app.profileIdentityService.updateProfileV2(reqObj).then(() => {
        app.appUtil.navigateToFromLogin(app.appUtil.getAppRoutes().LOGIN.CHANGE_PASSWORD);
      }).catch(() => { /* This is intentional */ });
      return;
    }
    app.profileIdentityService.updateProfileV2(reqObj).then(() => {
      // app.identityService.activate();
      app.appService.removeSessionStorageItem(app.appService.appConstants.isPwdChanged);
    }).catch(() => { 
      /* This is intentional */ 
    }).finally(() => {
      const data = app.appService.getSessionstorage('activateReqObj');
      app.identityService.sessionService.setUpSessionInfo({...data, userOpted: 'NeverAsk'}, true);
    });
  }

  onEnterKeyPress = (event, func) => {
    if (event.key === 'Enter') {
      func();
    }
  };

  render() {
    if(this.state.showLoader){
      return <LoadIndicator showLoading />;
    }
    return (
      <MfaModal isOpen>
        <h2 className={classes.textHeading}>{this.strings.heading}</h2>
        <p className={classes.content}>
          {this.strings.content}
        </p>
        <p>
          If you decide to make changes in the future, simply visit <span className={classes.innerText} onClick={() => this.handleNeverAsk(true)} onKeyDown={(event) => this.onEnterKeyPress(event, () => this.handleNeverAsk(true))} tabIndex={0}>Profile Settings</span> in your My Account Profile.
        </p>
        <div>
          <button onClick={() => this.handleNeverAsk(false)} className={classes.continue}>
            <span className={classes.continueText}>{this.strings.continue}</span>
          </button>
        </div>
      </MfaModal>
    );
  }
}

export default NeverAskAgainPopup;
